import { axiosV4 } from "../../../Utils/Axios/axiosV4";

export const getSamplePdfsService = async (
  userToken: string,
  params: { categoryId: string | number },
) => {
  return axiosV4.get(`/user/sample-exams/pdfs?sample_exam_category_id=${params.categoryId}`, {
    headers: {
      Authorization: `Bearer ${userToken}`,
    },
  });
};
